import { Box, Button, Flex, Input, Text } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useMarkup } from '../../contexts/MarkupProvider'
import SelectUsage from './Select'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const valueMes = [
  { value: '01', label: 'Janeiro' },
  { value: '02', label: 'Fevereiro' },
  { value: '03', label: 'Março' },
  { value: '04', label: 'Abril' },
  { value: '05', label: 'Maio' },
  { value: '06', label: 'Junho' },
  { value: '07', label: 'Julho' },
  { value: '08', label: 'Agosto' },
  { value: '09', label: 'Setembro' },
  { value: '10', label: 'Outubro' },
  { value: '11', label: 'Novembro' },
  { value: '12', label: 'Dezembro' },
]

const valueAno = [
  { value: '2023', label: '2023' },
  { value: '2024', label: '2024' },
  { value: '2025', label: '2025' },
  { value: '2026', label: '2026' },
  { value: '2027', label: '2027' },
]

const schema = yup.object().shape({
  numero_pedido: yup
    .string()
    .test(
      'len',
      'O número do pedido deve ter no mínimo 6 caracteres',
      (val) => {
        if (val) {
          return val.length >= 6
        }
        return true
      }
    ),
})

export function Filtro() {
  const [click, setClick] = useState({
    vendas: false,
    ano: false,
  })
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
  })

  const { getInfoMarkup, setLoading, defaultValueMes, defaultValueAno } =
    useMarkup()

  function getFilterMarkup(data) {
    setLoading(true)
    getInfoMarkup(data)
  }

  useEffect(() => {
    getFilterMarkup({ mes: defaultValueMes, ano: defaultValueAno })
  }, [])

  return (
    <Flex
      gap={2}
      as="form"
      alignItems="center"
      onSubmit={handleSubmit(getFilterMarkup)}
      bgColor="#ebebeb"
      paddingBlock="1rem"
      width="100%"
      justifyContent="center"
    >
      <Box
        paddingInline={4}
        bg="white"
        borderRadius={3}
        display="flex"
        alignItems="center"
        height="fit-content"
        position="relative"
      >
        <Text as="span" fontWeight={'bold'} color="#435E69">
          Busca:
        </Text>
        <Input
          color="#1A8AB6"
          fontWeight={'bold'}
          maxHeight="2.3rem"
          border={0}
          {...register('numero_pedido')}
          _focus={{ outline: 'none' }}
        />
        {errors.numero_pedido && (
          <Text
            as="span"
            color="red.500"
            fontSize="12px"
            position="absolute"
            top="2.5rem"
          >
            {errors.numero_pedido.message}
          </Text>
        )}
      </Box>
      <Box
        paddingBlock={2}
        paddingInline={4}
        bg="white"
        borderRadius={3}
        outline={click.quantidade ? '1px solid #1A8AB6' : 'none'}
      >
        <SelectUsage
          label="Mês"
          value={valueMes}
          defaultValue={defaultValueMes}
          setClick={() => setClick({ ...click, quantidade: true })}
          onBlur={() => setClick({ ...click, quantidade: false })}
          {...register('mes')}
        />
      </Box>
      <Flex alignItems="center" gap={2}>
        <Input
          type="date"
          height="2.1rem"
          border={0}
          {...register('data_entrada')}
        />
        <Input
          type="date"
          height="2.1rem"
          border={0}
          {...register('data_saida')}
        />
      </Flex>

      <Box
        paddingBlock={2}
        paddingInline={4}
        bg="white"
        borderRadius={3}
        outline={click.ano ? '1px solid #1A8AB6' : 'none'}
      >
        <SelectUsage
          label="Ano"
          value={valueAno}
          // defaultValue={defaultValueAno}
          setClick={() => setClick({ ...click, ano: true })}
          onBlur={() => setClick({ ...click, ano: false })}
          {...register('ano')}
        />
      </Box>
      <Button
        colorScheme="blue"
        size="sm"
        bg="#0481B3"
        borderRadius={4}
        type="submit"
      >
        Aplicar filtro
      </Button>
      <Button
        colorScheme="blue"
        variant="ghost"
        size="sm"
        borderRadius={4}
        type="reset"
      >
        Limpar filtro
      </Button>
    </Flex>
  )
}
